export const GET_ALBUM_BEGIN = "GET_ALBUM_BEGIN";
export const GET_ALBUM_SUCCESS = "GET_ALBUM_SUCCESS";
export const GET_ALBUM_ERROR = "GET_ALBUM_ERROR";

export const GET_ALBUM_SINGLE_BEGIN = "GET_ALBUM_SINGLE_BEGIN";
export const GET_ALBUM_SINGLE_SUCCESS = "GET_ALBUM_SINGLE_SUCCESS";
export const GET_ALBUM_SINGLE_ERROR = "GET_ALBUM_SINGLE_ERROR";
